import React, { memo } from "react";
import { Modal } from "react-bootstrap";

const StopFullLengthExamAttempt = ({ open, onClose, title, message }) => {
  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
    </Modal>
  );
};

export default memo(StopFullLengthExamAttempt);
